import { TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export class CustomTranslateLoader implements TranslateLoader {
	constructor(private http: HttpClient) {}

	getTranslation(lang: string): Observable<any> {
		return this.http.get(`/assets/i18n/${lang ?? 'en'}.json`);
	}
}

export function createTranslateLoader(http: HttpClient) {
	return new CustomTranslateLoader(http);
}
